(function ($) {
    $(() => {


        var langCookie = Cookies.get('_icl_current_language');
        if (langCookie == undefined) {
            langCookie = Cookies.get('wp-wpml_current_language');
        }

        moment.locale(langCookie);

        if ($('.single-shows').length) {
            axios.post(
                localize.ajaxurl,
                $.param({
                    action: 'get_epg',
                    post_id: localize.post_id,
                    lang: langCookie,
                })
            ).then(function (response) {
                if (response.data.length) {
                    $.each(response.data, function (i, e) {
                        var schedule = e.schedule_start;
                        $('figure ul').append(`
                                <li>${moment(schedule).format('D MMMM - ') + moment(schedule).format('HH:mm')}</li>
                            `);
                    });
                } else {
                    $('figure ul').append(`
                            <li>${localize.translations.noprogrammes}</li>
                        `);
                }

                $('.figure-inside').fadeIn('fast');
            }).catch(function (error) {
                console.log(error);
            });
        }


        let currentRequest = null;

        /* EPG PAGE TEMPLATE */
        function get_epg(epg_day, init) {

            // cancel  previous ajax if exists
            if (currentRequest) {
                currentRequest.cancel();
            }

            // creates a new token for upcomming ajax (overwrite the previous one)
            currentRequest = axios.CancelToken.source();


            axios.post(
                localize.ajaxurl,
                $.param({
                    action: 'get_epg_for_a_day',
                    lang: langCookie,
                    date: epg_day
                }), {
                cancelToken: currentRequest.token
            }
            ).then(response => {
                const rd = response.data;
                const dateMin = moment(rd.date_min);
                const dateMax = moment(rd.date_max);

                if (init) {
                    /* EPG */
                    for (let m = moment(dateMin), i = 0; moment().diff(m, 'days') >= -13; m.add(1, 'days'), i++) {
                        const currentDate = m.format('YYYY-MM-DD');
                        $('.js-epg-slider').append(`
                            <div class="epg__date js-epg-date ${today == currentDate ? 'active' : ''}" data-date="${currentDate}" data-index="${i}">
                                <div class="date-wrapper">
                                    <div class="day__name">${m.format('dddd')}</div>
                                    <div class="day__number">${m.format('DD')}</div>
                                </div>
                            </div>
                        `);
                    }

                    $('#js-epg-slider').slick({
                        infinite: false,
                        initialSlide: $('.epg__date.active').data('index'),
                        slidesToShow: 9,
                        centerMode: false,
                        variableWidth: false,
                        nextArrow: $('.js-epg-arrow-right'),
                        prevArrow: $('.js-epg-arrow-left'),
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 7
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 6
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 500,
                                settings: {
                                    slidesToShow: 2
                                }
                            }
                        ]
                    });

                    $('.js-epg-slider').on('beforeChange swipe', () => {
                        $('.slick-active').find('.js-epg-date').css("border-right", "2px solid #1A3D68");
                    });

                    $('.js-epg-slider').on('afterChange', () => {
                        $('.slick-active').find('.js-epg-date').css("border-right", "2px solid #1A3D68");
                        $('.slick-active').last().find('.js-epg-date').css("border-right", "none");
                    });

                    $('.slick-active').find('.js-epg-date').css("border-right", "2px solid #1A3D68");
                    $('.slick-active').last().find('.js-epg-date').css("border-right", "none");
                }

                if (!init) {
                    $('.js-programmes').html('');
                }

                let first_show = true;

                $.each(rd.shows, (i, e) => {
                    const end = moment(e.schedule_end);
                    const start = moment(e.schedule_start);
                    const $shows = e.shows;

                    $('.js-programmes').append(`
                        <a href="${e.permalink}" class="programme ${end.format('YYYY-DD-MM HH:mm:ss') < moment().format('YYYY-DD-MM HH:mm:ss') && epg_day == today ? 'hide-programme' : ''}">
                            <div class="programme__time">
                                <h2>${start.format('HH:mm')}</h2>
                            </div>
                            
                            <div class="programme__lead">${e.lead_image && e.lead_image != 0 ? `<img class="ofi-cover-center" src="${e.lead_image}" alt="">` : ``}</div>
    
                            <div class="programme__detail">
                                <h2 class="time">${start.format('HH:mm')}</h2>
                                <h2>${e.name}</h2>
                                <small>${e.episode_name && e.episode_name != 0 ? `${e.episode_name}, ` : ``} ${e.season && e.season != 0 ? `${e.season} / ${e.episode_no}` : ``}</small>
                            </div>
                        </a>
                    `);

                    if (end.format("YYYY-DD-MM HH:mm:ss") >= moment().format("YYYY-DD-MM HH:mm:ss") && epg_day == today && first_show) {
                        if (localize.is_banner_enabled) {
                            $('.js-programmes').append(rd.banner);
                            first_show = false;
                        }
                    } else if (epg_day != today && first_show) {
                        if (localize.is_banner_enabled) {
                            $('.js-programmes').append(rd.banner);
                            first_show = false;
                        }
                    }
                });

                if (epg_day == today && $('.hide-programme').length) {
                    $('.js-programmes').prepend(`
                        <div class="programme__info">
                            <h2 class="current-date"><span class="color-green">${moment(epg_day).format('dddd, ')}</span>${moment(epg_day).format('DD MMMM')}</h2>
                            <button class="btn btn-epg active js-epg-prev">
                                <span>${localize.translations.earlierprogrammes}</span>
                            </button>
                        </div>
                        
                    `);
                } else {
                    $('.js-programmes').prepend(`
                        <div class="programme__info">
                            <h2 class="current-date"><span class="color-green">${moment(epg_day).format('dddd, ')}</span>${moment(epg_day).format('DD MMMM')}</h2>
                        </div>
                    `);
                }

                if (init) {
                    $('.page-load-status').fadeOut(200, () => {
                        $('#js-epg-slider').slick('refresh');
                        $('.epg__slider_wrapper').fadeIn('fast');
                        $('.template-epg').removeClass('full-height');
                    });
                } else {
                    $('.page-load-status').fadeOut('fast', () => {
                        $('.js-programmes').fadeIn('fast');
                        $('.template-epg').removeClass('full-height');
                    });
                }
            }).catch(error => {
                console.log(error);
            });
        }

        if ($('.template-epg').length) {
            var today = moment().format('YYYY-MM-DD');

            get_epg(today, true);

            $(document).on('click', '.js-epg-date', function (e) {
                e.preventDefault();
                const date = $(this).data('date');
                $('.js-epg-date.active').removeClass('active');
                $(this).addClass('active');
                $('.js-programmes').fadeOut('fast', () => {
                    $('.page-load-status').fadeIn('fast', () => {
                        get_epg(date, false);
                    });
                });
            });

            $(document).on('click', '.js-epg-prev', function (e) {
                e.preventDefault();
                $(this).fadeOut('fast', () => { });
                $('.hide-programme').fadeToggle('400').css('display', 'flex');
            });
        }
    });
})(jQuery);
